import useApiMutation from '@src/hooks/useApiMutation';
import { CalendarEvent } from '@src/types/Events';

export default (id?: string) => {
  const eventPath = `/events${id ? `/${id}` : ''}`;
  const createCalendarEvent = useApiMutation<CalendarEvent, CalendarEvent>({
    apiPath: eventPath,
    method: 'POST',
    useV2API: true,
  });

  const updateCalendarEvent = useApiMutation<CalendarEvent, CalendarEvent>({
    apiPath: eventPath,
    method: 'PATCH',
    useV2API: true,
  });

  const deleteCalendarEvent = useApiMutation({
    apiPath: eventPath,
    method: 'DELETE',
    useV2API: true,
  });

  return {
    createCalendarEvent,
    updateCalendarEvent,
    deleteCalendarEvent,
  };
};
